import React, { useRef } from 'react';
import styled from 'styled-components';
import { Wrapper } from '@catalogo/theme-wrapper';
import withQnA from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/qna';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box-new';
import { QuestionForm } from '@catalogo/ui-americanas-desktop-product-form/src/components/organisms/QuestionForm';
import QuestionsAndAnswersList from '@catalogo/ui-americanas-mobile-qna/src/components/template/ContainerQuestions';
import { HasNoQuestions } from '../../molecules';
import { CustomerQuestion } from '../../organisms';
import { IQnA } from '../../../types';

const Content = styled.div`
  background-color: #fff;
`;

const ThemeWrapper = styled.div`
  text-transform: ${({ theme }) => theme.titleTransform};
`;

// eslint-disable-next-line max-lines-per-function
export const QnA = ({
  questionsAndAnswers,
  hasCustomerQuestions,
  hasQuestions,
  fetchMore,
  productId,
  loading,
  hasOffers,
  clientQuestion,
  product,
  config,
  dispatchMetrics,
}: IQnA) => {
  const ref = useRef(null);

  return (
    <ThemeWrapper>
      <AccordionBox
        ref={ref}
        title="Dúvidas sobre o produto"
        shouldGetElementHeightOnRender={false}
        visibilityOnInit={true}
        metricId="q&a"
        id="qna-wrapper"
        anchorRef="#qna-wrapper"
      >
        {!questionsAndAnswers ? (
          <></>
        ) : (
          <Wrapper>
            <Content>
              {hasQuestions ? (
                <QuestionForm
                  className="primary"
                  productId={productId}
                  config={config}
                  product={product}
                  dispatchMetrics={dispatchMetrics}
                  metricParams={{
                    category: 'qna-pdp',
                    action: 'fazer-pergunta',
                    label: 'area-qna',
                  }}
                >
                  Fazer pergunta
                </QuestionForm>
              ) : (
                <></>
              )}
              <CustomerQuestion
                customerQuestions={clientQuestion}
                hasCustomerQuestions={hasCustomerQuestions}
                isDesk={false}
              />
              {!hasQuestions ? (
                <HasNoQuestions
                  productId={productId}
                  product={product}
                  config={config}
                  dispatchMetrics={dispatchMetrics}
                  mobile={true}
                />
              ) : (
                <QuestionsAndAnswersList
                  questionsAndAnswers={questionsAndAnswers}
                  fetchMore={fetchMore}
                  productId={productId}
                  loading={loading}
                  hasOffers={hasOffers}
                  product={product}
                  config={config}
                  dispatchMetrics={dispatchMetrics}
                />
              )}
            </Content>
          </Wrapper>
        )}
      </AccordionBox>
    </ThemeWrapper>
  );
};

export default withQnA(QnA);
